var map = {
	"./Bullet": 0,
	"./Bullet.svg": 0,
	"./GettyImages-1251678849-headerimage": 1,
	"./GettyImages-1251678849-headerimage.jpg": 1,
	"./Guide Image": 2,
	"./Guide Image.jpg": 2,
	"./Header image - mobile": 3,
	"./Header image - mobile.jpg": 3,
	"./SpillCenter-Logo_v1": 4,
	"./SpillCenter-Logo_v1.svg": 4
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;